export const MenuItems = [
    {
        title: 'Home',
        url: 'landingpage',
        cName: 'nav-links'
    },
    {
        title: 'About',
        url: 'about',
        cName: 'nav-links'
    },
    {
        title: 'Skills',
        url: 'skills',
        cName: 'nav-links'
    },
    // {
    //     title: 'Services',
    //     url: 'service',
    //     cName: 'nav-links'
    // },
    {
        title: 'Projects',
        url: 'projects',
        cName: 'nav-links'
    },
    {
        title: 'Contact',
        url: 'contact',
        cName: 'nav-links'
    }
]